import { useEditTransactionRuleContext } from '../../EditTransactionRuleContext';
import { useFormDirtyFields } from '../../useFormDirtyFields';

export const ChangesCounter = () => {
  const { form } = useEditTransactionRuleContext();
  const { findDirtyFields } = useFormDirtyFields();
  let counter = findDirtyFields([
    'name',
    'description',
    'selectors',
    'dynamicResponseModifiers',
    'response',
    'customModifier',
  ]).length;

  if (form.getValues('representationType') === 'form') {
    counter += Math.min(
      1,
      findDirtyFields(['representationType', 'representationFields']).length
    );
  } else {
    counter += Math.min(1, findDirtyFields(['representationType']).length);
  }

  if (!counter) {
    return null;
  }

  const getCountText = (count) => {
    return `${count} Change${count > 1 ? 's' : ''}`;
  };

  return (
    <span className="text-sm font-normal text-ds-natural-300">
      {getCountText(counter)}
    </span>
  );
};
